import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import reportWebVitals from './reportWebVitals';
import './main.scss';
import '../src/assets/css/CommonStyle.module.scss';
import { BrowserRouter } from 'react-router-dom';

if (typeof window === 'object') {
  window.store = store;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
